var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr15"},[_c('h4',{staticClass:"comm_tit02"},[_vm._v("\n    "+_vm._s(_vm.title02)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }